import { axios } from '../util/axios'

const API_ENDPOINT = '/v1/accounts/my/email/send'

export default () =>
  axios.post(API_ENDPOINT, {}, { withCredentials: true }).then(response => response.data)
